import md5 from 'js-md5'

export default {
  authorization: function () {
    const tokenPrincipal = this.storageGetObj('token.principal')
    const tokenCredentials = this.storageGetObj('token.credentials')
    const timestamp = new Date().getTime()
    if (!tokenPrincipal) {
      return ''
    }
    if (!tokenCredentials) {
      return ''
    }
    let credentials = md5(tokenPrincipal + tokenCredentials)
    credentials = md5(credentials + timestamp)
    const authKey = btoa(tokenPrincipal + '.' + credentials + '.' + timestamp)
    return authKey
  },
  storagePut: function (key, value) {
    sessionStorage.setItem(key, value)
  },
  storageGet: function (key) {
    return sessionStorage.getItem(key)
  },
  storagePutObj: function (key, value) {
    if (!value) {
      this.storagePut(key, value)
    }
    sessionStorage.setItem(key, JSON.stringify(value))
  },
  storageGetObj: function (key) {
    const value = sessionStorage.getItem(key)
    if (!value) {
      return value
    }
    return JSON.parse(value)
  }
}
